import type { FaireProductEntity } from "../../entity_types/product";

export const p_8qgn78wy22: FaireProductEntity = {
  token: "p_8qgn78wy22",
  type: "product",
  name: "Coquette Pumpkin Knit Sweater - Girls Clothes - Fall",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/c41f2ada040a23c932274a37440d252c4ebbc35a0085425e17e59886b866bd06.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcef9e210780e37310692e48a6969636c8be107d7547abd178b9e3944ff6ea94.jpeg",
    "https://cdn.faire.com/fastly/bf8467d0d7bc50a2b232cb6bf8436d6dc778204caeca312f016ce9f8c0caef78.jpeg",
    "https://cdn.faire.com/fastly/157039d3929d6c7534f61737240c2a6cac9975b48ddc2837875ffb65a1181ad6.jpeg",
    "https://cdn.faire.com/fastly/2ee09d447421a38bf97eb53a03ab05d3bf646bae0c050b96df4057e4d834d6e1.jpeg",
    "https://cdn.faire.com/fastly/b4816116119ce4884ea6a7c6fcf4aec8507da286e72c91c2ebe9844522528841.jpeg",
    "https://cdn.faire.com/fastly/6741d1ab2e4f47f64e91212c7cd146a7402f1c22cb9a4b5492a091e91a9f2cf7.jpeg",
  ],
  priceDollars: 30,
  description:
    "The Coquette Pumpkin Knit Sweater is a fun and festive sweater for celebrating Fall!\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬:\n• Sweater Color: Pink\n• Embroidery Color: Orange, Dusty Rose, Brown\n• Material: 100% Acrylic\n• Fit: Moderately oversized\n• Care: Hand wash only, do not iron, tumble dry, bleach or dry clean\n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 60,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-12T07:12:33.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
